import React from 'react';
import { personalInfo, socialLinks } from '../data/portfolioData';
import { FaArrowDown } from 'react-icons/fa';
import Icon from './Icon';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero">
      <div className="container hero-content">
        <p className="hero-greeting">Ciao, mi chiamo</p>
        <h1 className="hero-name">
          <span className="highlight">{personalInfo.name}</span>
        </h1>
        <h2 className="hero-title">{personalInfo.title}</h2>
        <p className="hero-description">{personalInfo.subtitle}</p>

        <div className="hero-actions">
          <a href="#skills" className="btn btn-primary">
            Scopri le mie competenze
            <Icon icon={FaArrowDown} />
          </a>
          <a href="#contact" className="btn btn-outline">
            Contattami
          </a>
        </div>

        <div className="hero-social">
          {socialLinks.map(link => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              title={link.name}
            >
              <Icon icon={link.icon} />
            </a>
          ))}
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="mouse"></div>
        <span>Scorri</span>
      </div>
    </section>
  );
};

export default Hero;
